import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { selectAllLicence } from 'src/app/store/selector/licence.selector';

@Injectable({
  providedIn: 'root'
})
export class LicenceStatusService {
  private currentUserInspectionId: number | null = null;

  constructor(private store: Store<any>) {
    this.currentUserInspectionId = localStorage.getItem('InspectionId') ?
      +localStorage.getItem('InspectionId')! : null;
  }

  getUserLicence(): Observable<any> {
    return this.store.pipe(
      select(selectAllLicence),
      map((licenceState: any) => {
        if (licenceState?.licences?.content) {
          console.log('Licences from store:', licenceState.licences.content);
          const licences = licenceState.licences.content;
          console.log('Current user licence', licences.find((licence: any) =>
            licence.partenaire?.inspection?.id === this.currentUserInspectionId
          ));
          return licences.find((licence: any) =>
            licence.partenaire?.inspection?.id === this.currentUserInspectionId
          );
        }
        return null;
      })
    );
  }

  isLicenceActive(): Observable<boolean> {
    return this.getUserLicence().pipe(
      map(licence => {
        if (!licence) return false;
        console.log('Licence found for user:', licence);
        // Vérifier si la licence est active et non expirée
        const isActive = licence.status === 'ACTIF';
        console.log('Licence status:', licence.status === 'ACTIF');
        // Optionnel: vérifier la date d'expiration
        const today = new Date();
        const expirationDate = licence.dateExpiration ? new Date(licence.dateExpiration) : null;
        const notExpired = expirationDate ? expirationDate > today : true;

        return isActive && notExpired;
      })
    );
  }
}
